import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { Message } from '../models'


@Injectable()
export class MessageRelayService {

    _message$: Subject<Message> = <Subject<Message>> new Subject();
    get message$() { return this._message$.asObservable();}

    constructor(){}

    public send(message: Message) {
         this._message$.next(message);
    }
}